module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av406-2d873f524c48bc93c0c54eab6d75c1b9.jpg";